// This is the component that displays the cards themselves on the individual pages (recipe, grocery)
import InfiniteScroll from 'react-infinite-scroller';

import RecipePairingCard from './RecipePairingCard';
import CProductCard from './CProductCard';
import { applySkuFilters } from '../../customize/actions_creators';
import { commaNumber, hasAppliedFilters } from '../../utils/utils';
import HeightButton from '../../generic/HeightButton';
import {
  infiniteScrollNextLoadOffset,
  isFoodsPage,
} from '../../customize/const';
import clsx from 'clsx';
import styles from './DisplayedCardContainer.module.css';
import CPairingCard from './CPairingCard';
import { useFeatureFlag } from '@hungryroot/feature-flags';

const DisplayedCardContainer = ({
  isRecipe,
  items,
  loadMoreFunc,
  hasMore,
  clearFunc,
  appliedFilters,
  totalCount,
  appliedSearchText,
  children,
}) => {
  if (!items) {
    return;
  }
  const isMobile = $.browser.mobile;

  const preCheckout = !!parseInt(window.preCheckout);

  const renderCards = () =>
    items.map((ele, _) =>
      isRecipe ? (
        <RecipePairingCard key={ele['id']} data={ele} />
      ) : (
        <CProductCard key={ele['id']} data={ele} />
      )
    );

  const scrollToTop = () => window.scrollTo(0, 0);

  const surveyStaredFoods = window.surveyStarted;
  const cookbookPathCta = surveyStaredFoods ? '/signup' : '/limited-time/';
  const cookbookTextCta = surveyStaredFoods
    ? 'Finish quiz'
    : isFoodsPage
      ? 'Sign up to get groceries'
      : 'Sign up to get recipes';

  const scrollAndRunFunc = () => {
    scrollToTop();
    clearFunc();
  };

  const renderPrecheckoutMsg = () => {
    return (
      <div className={'end-of-aisle-container precheckout'}>
        <img
          src={`/public/img/recipe_search/empty_box.svg`}
          className="hr-mb-32"
          alt="Empty box"
        />
        <div className={`hr-title-md hr-mb-32`}>Hungry yet?</div>
        <div className={`msg-container hr-paragraph`}>
          {isFoodsPage ? (
            <div>
              <a href={`/${surveyStaredFoods ? 'signup' : 'limited-time'}/`}>
                Take our quiz{' '}
              </a>
              and we’ll suggest groceries and recipes you’ll love.
            </div>
          ) : (
            <div>
              <a href={`/${surveyStaredFoods ? 'signup' : 'limited-time'}/`}>
                Sign up
              </a>{' '}
              to access thousands more top-rated, chef-designed recipes.
            </div>
          )}
        </div>
      </div>
    );
  };

  const renderEndOfAisleMsg = () => {
    return (
      <div className={'end-of-aisle-container'}>
        <div className={'hr-bold eol-header'}>
          You've reached the end of the aisle.
        </div>
        <div className={'msg-text'}>
          Want to
          <button className={'scroll-to-top'} onClick={scrollToTop}>
            &nbsp;go back to the top
          </button>
          ?
          <br className={styles['hr-mobile']} />
          &nbsp;Or{' '}
          <button className={'clear-filters-eol'} onClick={scrollAndRunFunc}>
            clear all your filters + searches
          </button>
          ?
        </div>
      </div>
    );
  };

  const renderNullResultMsg = () => {
    return (
      <div className={'null-filter-result-msg-container'}>
        <div className={'hr-title-md'}>
          Whoops! Looks like this aisle <br />
          is empty at the moment.
        </div>
        <img
          src={`/public/img/edit_delivery/empty-illustration.svg`}
          alt="Empty illustration"
        />
        <div>
          Click{' '}
          <button onClick={clearFunc}>clear all filters + searches</button> and
          see what else is available.
        </div>
      </div>
    );
  };

  const selectAndRenderMsg = () => {
    if (
      (hasAppliedFilters(appliedFilters) && !items.length) ||
      (appliedSearchText && !items.length)
    ) {
      if (preCheckout) {
        return renderPrecheckoutMsg();
      }
      return renderNullResultMsg();
    } else if (!hasMore) {
      if (preCheckout) {
        return renderPrecheckoutMsg();
      }
      return renderEndOfAisleMsg();
    }
  };

  const containerClasses = clsx(
    'items-display-container',
    isRecipe ? 'recipes' : 'skus',
    hasAppliedFilters(appliedFilters) && !items.length ? 'no-items' : '',
    {
      tall:
        $('.items-display-container div:nth-child(2)').height() >
        window.innerHeight,
    }
  );

  const renderTotalCount = () => {
    if (preCheckout) {
      return;
    }
    if (totalCount) {
      return (
        <div className={'hr-paragraph results-count'}>
          {totalCount !== 1
            ? `${commaNumber(totalCount)} results`
            : `${totalCount} result`}
        </div>
      );
    }
  };

  return (
    <div className={`${containerClasses} ${preCheckout ? 'pc' : ''}`}>
      {children}
      {renderTotalCount()}
      {preCheckout ? (
        <HeightButton
          displayHeight={300}
          path={cookbookPathCta}
          btnText={cookbookTextCta}
          btnClass={'hr-btn-blue hr-wide cta-btn'}
        />
      ) : null}

      <InfiniteScroll
        pageStart={0}
        loadMore={() => loadMoreFunc(true)}
        hasMore={hasMore}
        initialLoad={false}
        useWindow={true}
        threshold={infiniteScrollNextLoadOffset}
        loader={
          <div
            className={'loader-container-items'}
            key={`${isRecipe ? 'r' : 's'}-key`}
          >
            <img
              className={'loading-gif'}
              src={`/public/img/edit_delivery/load.svg`}
              alt="Loading icon"
            />
          </div>
        }
      >
        {renderCards()}
        {selectAndRenderMsg()}
      </InfiniteScroll>
    </div>
  );
};

export default DisplayedCardContainer;
